module.exports = __webpack_public_path__ + "static/media/hut-image.a09cd9e8.png";